<div class="main-container">
    <img
        alt="404 NOT FOUND"
        class="illustration"
        src="assets/images/illustrations/page-not-found.svg"
    />

    <p
        class="title"
        i18n
        style="color: #fff"
    >
        LOST IN SPACE?
    </p>
    <p
        class="accent-text"
        i18n
        style="color: #fff"
    >
        The page you requested could not be found
    </p>
    <button
        (click)="backHandler()"
        class="big-button go-back-button"
        color="primary"
        i18n
        mat-flat-button
    >
        GO BACK
    </button>
</div>
